import {
  TEAMS_LOADER,
  DOWNLOAD_COUNT,
  SET_TEAMS_DATA,
  SET_TEAM_DETAIL_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  teamDetail: {},
  teams: {},
};

const teamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEAMS_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_TEAMS_DATA: {
      return {
        ...state,
        teams: action.payload,
      };
    }
    case SET_TEAM_DETAIL_DATA: {
      return {
        ...state,
        teamDetail: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload === "fileview") {
        return {
          ...state,
          teamDetail: {
            ...state.teamDetail,
            fileViewCount: (state.teamDetail?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          teamDetail: {
            ...state.teamDetail,
            downloadCount: (state.teamDetail?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default teamsReducer;
